// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__jlts9","bigColWidth":"Table_bigColWidth__aNs3M","biggerColWidth":"Table_biggerColWidth__2w5x5","row":"Table_row__1uTL9","col":"Table_col__3WFIJ"};